Vue.component("banner-top-view", {
    props: {
        background:
        {
            type: String,
            default: "#fe1251"
        },
        color:
        {
            type: String,
            default: "#fff"
        }
        
    },
    data() {
        return {
            bannerclosed: false,
        };
    },
    mounted() {
        console.log(sessionStorage.getItem('banner-header-close'))
        if(sessionStorage.getItem('banner-header-close')){
            this.bannerclosed = true;
        }      
    },
    methods:
    {
        closeBanner: function(activeView){
            sessionStorage.setItem('banner-header-close', 'true');
            $('.top-header-banner').remove();
        }
    }
});
